import { useMutation } from '@tanstack/react-query'
import { useVendorsApiClient } from 'vendors/api/useVendorsApiClient'

export const useUpdateProposal = (proposalId: string) => {
  const { updateProposal } = useVendorsApiClient()
  return useMutation({
    mutationFn: (payload: ProposalUpdateRequestType) => updateProposal(proposalId, payload)
  })
}
